<script lang="ts">
    import HeartEmptyIcon from "@apps/wishlist/components/icons/HeartEmptyIcon.svelte";
    import { WishlistsStorefrontValuesBrandingEntity } from "@apps/wishlist/entities/WishlistsStorefrontValuesBrandingEntity";
    import { URLsBuilder } from "@modules/common_module/URLsBuilder/URLsBuilder";

    import EmptyState from "@components/EmptyState/EmptyState.svelte";
    import Icon from "@components/Icon.svelte";
    import WishlistIcon from "@components/WishlistIcon/WishlistIcon.svelte";

    export let wishlistIconSettings: WishlistsStorefrontValuesBrandingEntity["wishlistIconSettings"];
    export let urlsBuilder: URLsBuilder;
</script>

<EmptyState>
    <svelte:fragment slot="icon">
        <div class="gw-wl-empty-state__icon-wrapper">
            <Icon width={80} height={66} viewBox="0 0 80 66">
                <HeartEmptyIcon />
            </Icon>
            <div class="gw-wl-empty-state__heart-icon">
                <WishlistIcon
                    width={24}
                    height={24}
                    isFilled={false}
                    iconSettings={wishlistIconSettings}
                />
            </div>
        </div>
    </svelte:fragment>

    <h4 class="gw-empty-state__title" slot="title">
        <slot name="title" />
    </h4>

    <div slot="content" class="gw-empty-state__content">
        <p class="gw-empty-state__description">
            <slot name="description" />
        </p>
        <WishlistIcon
            width={20}
            height={20}
            isFilled={false}
            iconSettings={wishlistIconSettings}
        />
    </div>

    <a href={urlsBuilder.createCollectionAllUrl()} slot="footer">
        <slot name="browseLinkText" />
    </a>
</EmptyState>

<style lang="postcss">
    .gw-empty-state__content {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
    }

    .gw-empty-state__title {
        text-align: center;
        margin-bottom: 8px;
        padding: 0;
        margin: 0;
        font-size: 0.875em;
    }

    .gw-empty-state__description {
        text-align: center;
        margin: 0;
        padding: 0;
        font-size: 0.75em;
        color: var(--gw-theme-main-text-primary);
    }

    .gw-wl-empty-state__icon-wrapper {
        position: relative;
    }

    .gw-wl-empty-state__heart-icon {
        --gw-wl-wishlistIconSettings-heartColor: #777e90;

        position: absolute;
        top: 55%;
        left: 48%;
        transform: translate(-50%, -50%);
        color: #aab2c5;
    }
</style>
